import { Injectable, inject } from '@angular/core';
import { IHttpOptions } from '@partners/http';
import { Observable, distinctUntilChanged, of, startWith, switchMap } from 'rxjs';
import { TBankBranchOption, TCatalogOption, TResidenceOption } from '../model';
import { CatalogService } from './catalog.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogQuery {
  private _catalogService = inject(CatalogService);

  constructor() {}

  findResidence(residenceCode: number): TResidenceOption {
    const residenceList: TResidenceOption[] = this._catalogService.fromResidence();
    const residence = residenceList.find(({ value }) => value === residenceCode);
    return residence;
  }

  findBank(bankCode: number): TCatalogOption {
    const bankList: TCatalogOption[] = this._catalogService.fromFinance('bank');
    const bank = bankList.find(({ value }) => value === bankCode);
    return bank;
  }

  findBranchesForBank(bankCode: number): TBankBranchOption[] {
    const branchList: TBankBranchOption[] = this._catalogService.fromFinance('bankBranch');
    const bankBranches = branchList.filter((branch) => branch.bankCode === bankCode);
    return bankBranches;
  }

  findBankBranch(branchCode: number, bankCode: number): TBankBranchOption {
    const bankBranches = this.findBranchesForBank(bankCode);
    const branch = bankBranches.find(({ value }) => value === branchCode);
    return branch;
  }

  filterStreetsByName$(
    streetQuery: string,
    residenceCode: string | number,
    options: IHttpOptions = {}
  ): Observable<TCatalogOption[]> {
    return of(streetQuery).pipe(
      startWith(null),
      distinctUntilChanged(),
      switchMap(() => {
        options = { ...options, params: { residenceCode, streetQuery } };

        return this._catalogService.requestCatalog$<TCatalogOption[]>('streets', options);
      })
    );
  }
}
